import { useForm } from '../../xr/hook/useForm';
import { stringIncludes } from '../../util/stringIncludes';
export function useInputSearch() {
    var search = useForm([
        {
            field: 'keyword',
            type: 'string',
            placeholder: 'Type to search',
            nullable: true,
        },
    ]);
    return {
        value: search.getDataField('keyword'),
        element: search.getInput('keyword'),
        filter: function (items, field) {
            return items.filter(function (item) { return stringIncludes(item[field], search.getDataField('keyword')); });
        },
        clear: function () {
            search.clear();
        },
    };
}
